/* ============================================================
   PM PDP V6 — Page JS (extracted from mockup)
   Handles: scroll-reveal, gallery thumb swap, sticky ATC trigger,
            subscriptions picker + price recompute, Okendo review CTA.
   Wishlist is handled separately by pm-wishlist.js (shared module).
   Only activates if body.pm-pdp-v6 is set.
   ============================================================ */
(function(){
  'use strict';
  if (!document.body.classList.contains('pm-pdp-v6')) return;

  // ---------- Scroll-reveal ----------
  var revealEls = document.querySelectorAll('.pm-pdp-v6 [data-reveal]');
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-in'); });
  }

  // ---------- Gallery thumbnail click ----------
  (function(){
    var rail = document.getElementById('v6-gallery-rail');
    var main = document.getElementById('v6-gallery-main');
    if (!rail || !main) return;
    rail.addEventListener('click', function(e){
      var thumb = e.target.closest('.thumb');
      if (!thumb || thumb.classList.contains('video')) return;
      var src = thumb.dataset.img;
      if (!src) return;
      rail.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('on'); });
      thumb.classList.add('on');
      main.style.opacity = '0';
      setTimeout(function(){ main.src = src; main.style.opacity = '1'; }, 180);
    });
  })();

  // ---------- Sticky ATC bar ----------
  var heroBlock = document.getElementById('v6-hero-block');
  var stickyBar = document.getElementById('v6-sec-23');
  if (heroBlock && stickyBar && 'IntersectionObserver' in window){
    var heroObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.intersectionRatio < 0.2) stickyBar.classList.add('show');
        else stickyBar.classList.remove('show');
      });
    }, { threshold: [0, 0.2, 0.5, 1] });
    heroObs.observe(heroBlock);
  }
  // Sticky ATC button triggers main form submit
  var stickyAtc = document.querySelector('.pm-pdp-v6 .s-23 .atc-s');
  if (stickyAtc){
    stickyAtc.addEventListener('click', function(){
      var form = document.getElementById('v6-bb-form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  // ---------- Variant size chip ----------
  var sizeWrap = document.querySelector('.pm-pdp-v6 .bb-sizes');
  var variantInput = document.getElementById('v6-current-variant');
  if (sizeWrap && variantInput){
    sizeWrap.addEventListener('click', function(e){
      var chip = e.target.closest('.chip');
      if (!chip) return;
      sizeWrap.querySelectorAll('.chip').forEach(function(c){ c.classList.remove('on'); });
      chip.classList.add('on');
      if (chip.dataset.variantId){
        variantInput.value = chip.dataset.variantId;
        var price = parseFloat(chip.dataset.variantPrice || '0') / 100;
        if (!isNaN(price) && price > 0){
          var form = document.getElementById('v6-bb-form');
          if (form){ form.dataset.basePrice = price.toFixed(2); refreshPrice(); }
        }
      }
    });
  }

  // ---------- Shopify Subscriptions: subscribe/onetime + price refresh ----------
  var form = document.getElementById('v6-bb-form');
  var hiddenPlan, freqSel, cards, pointsEl, klarnaEl, subPriceEls, curPriceEls, subDiscEl;
  function refreshPrice(){
    if (!form) return;
    var base = parseFloat(form.dataset.basePrice || '0');
    var cur  = form.dataset.currency || '$';
    var active = form.querySelector('.bb-commit .card.on');
    var mode = active ? active.dataset.mode : 'onetime';
    var d = 0, price = base, planId = '';
    if (mode === 'subscribe'){
      var subCard = form.querySelector('.card[data-mode="subscribe"]');
      var opt = freqSel && freqSel.options[freqSel.selectedIndex];
      d = opt ? parseFloat(opt.dataset.discount || (subCard ? subCard.dataset.discount : '0') || '0') : (subCard ? parseFloat(subCard.dataset.discount || '0') : 0);
      planId = opt ? opt.value : '';
      price = base * (1 - d/100);
      subPriceEls.forEach(function(el){ el.textContent = cur + price.toFixed(2); });
      if (subDiscEl) subDiscEl.textContent = String(Math.round(d));
    }
    curPriceEls.forEach(function(el){ el.textContent = cur + price.toFixed(2); });
    if (hiddenPlan) hiddenPlan.value = planId;
    if (pointsEl) pointsEl.textContent = String(Math.floor(price * 5));
    if (klarnaEl) klarnaEl.textContent = cur + (price / 3).toFixed(2);
  }
  if (form){
    hiddenPlan  = document.getElementById('v6-current-plan');
    freqSel     = document.getElementById('v6-bb-freq');
    cards       = form.querySelectorAll('.bb-commit .card');
    pointsEl    = form.querySelector('.js-points');
    klarnaEl    = form.querySelector('.js-klarna');
    subPriceEls = form.querySelectorAll('.js-sub-price');
    curPriceEls = document.querySelectorAll('.pm-pdp-v6 .js-current-price');
    subDiscEl   = form.querySelector('.js-discount');
    cards.forEach(function(card){
      card.addEventListener('click', function(e){
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION' || e.target.tagName === 'A') return;
        cards.forEach(function(c){ c.classList.remove('on'); });
        card.classList.add('on');
        refreshPrice();
      });
    });
    if (freqSel) freqSel.addEventListener('change', refreshPrice);
    refreshPrice();
  }

  // ---------- FAQ accordion ----------
  document.querySelectorAll('.pm-pdp-v6 .s-19 .faq').forEach(function(f){
    f.addEventListener('click', function(){ f.classList.toggle('open'); });
  });

  // ---------- AM/PM toggle in How To Use ----------
  var ampm = document.querySelector('.pm-pdp-v6 .s-13 .ampm');
  if (ampm){
    ampm.addEventListener('click', function(e){
      var span = e.target.closest('span');
      if (!span) return;
      ampm.querySelectorAll('span').forEach(function(s){ s.classList.remove('on'); });
      span.classList.add('on');
    });
  }

  // ---------- Okendo Write-a-review CTA ----------
  var reviewCta = document.getElementById('v6-rivo-review-cta');
  var reviewEarn = document.getElementById('v6-rivo-review-earn');
  function openOkendoReviewForm(e){
    if (e) e.preventDefault();
    try {
      if (window.okendoReviewsWidget && window.okendoReviewsWidget.openWriteReview){ window.okendoReviewsWidget.openWriteReview(); return; }
      if (window.OkendoWidgetClient && window.OkendoWidgetClient.openWriteReview){ window.OkendoWidgetClient.openWriteReview(); return; }
      var okeBtn = document.querySelector('[data-oke-reviews-widget-write-review-btn], [data-oke-reviews-modal-write-review-button], .oke-reviews-writeReview-button, button[data-oke-write-review]:not(#v6-rivo-review-cta)');
      if (okeBtn){ okeBtn.click(); return; }
    } catch(err){}
    var revs = document.querySelector('.pm-pdp-v6 .reviews-grid');
    if (revs) revs.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (reviewCta) reviewCta.addEventListener('click', openOkendoReviewForm);
  function markReviewSubmitted(){
    if (!reviewEarn) return;
    reviewEarn.classList.add('is-done');
    var copy = reviewEarn.querySelector('.copy');
    var cta  = reviewEarn.querySelector('.cta');
    if (copy) copy.innerHTML = '<span class="lbl">✓ Review submitted</span>Thanks — your <strong>250–500 points</strong> will appear once verified.';
    if (cta) cta.style.display = 'none';
  }
  ['okendo-review-submitted','okeReviewSubmitted','oke:reviews:submitted'].forEach(function(n){
    window.addEventListener(n, markReviewSubmitted);
    document.addEventListener(n, markReviewSubmitted);
  });

})();
